export const getTyreSize = (size) => {
  if (size) {
    let tyreSize = `${size.width}${size.profile ? `/${size.profile}` : ''}/${size.rimSize} ${
      size.loadIndex || ''
    }${size.speedRating || ''}`.trim()
    return tyreSize
  }
}

export const getSimpleTyreSize = (size) => {
  if (size) {
    let tyreSize = `${size.width || ''}${size.profile || ''}${size.rimSize || ''}${
      size.loadIndex || ''
    }${size.speedRating || ''}`
    return tyreSize
  }
}
